import { useContext } from 'react';

import { AssistedApplicationContext, AssistedApplicationContextProps } from '../Context/AssistedApplicationContext';

export function useAssistedApplicationContext(): AssistedApplicationContextProps {
  return useContext(AssistedApplicationContext);
}
